export default __webpack_public_path__ + "c82ec617dbc70997a87b33d3b0fc14f6.svg";